import { Satellite, ExternalLink, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const getStatusStyle = (status) => {
  if (status === "Over Florida!") return "text-emerald-400 bg-emerald-500/20 border-emerald-500/30";
  if (status === "Nearby") return "text-amber-400 bg-amber-500/20 border-amber-500/30";
  return "text-slate-400 bg-slate-500/20 border-slate-500/30";
};

export const ISSWidget = ({ iss, compact = false }) => {
  if (!iss) return null;

  if (compact) {
    return (
      <Link to="/iss" className="block" data-testid="iss-widget-compact">
        <div className="glass-card-hover p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-cosmic-blue/20">
                <Satellite className="w-5 h-5 text-cosmic-blue" strokeWidth={1.5} />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-widest font-heading">
                  ISS Status
                </p>
                <p className={`font-heading font-semibold ${
                  iss.is_over_florida ? "text-emerald-400" : 
                  iss.is_nearby ? "text-amber-400" : "text-slate-400"
                }`}>
                  {iss.status}
                </p>
              </div>
            </div>
            <div className="text-right text-xs text-slate-500">
              <p>Lat: {iss.latitude?.toFixed(2)}°</p>
              <p>Lon: {iss.longitude?.toFixed(2)}°</p>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <div className="glass-card p-6" data-testid="iss-widget">
      <div className="flex items-center justify-between mb-4">
        <h3 className="section-title">Space Station</h3>
        <span className={`status-badge ${getStatusStyle(iss.status)}`}>
          {iss.status}
        </span>
      </div>

      {/* Position */}
      <div className="bg-white/5 rounded-xl p-4 mb-4">
        <div className="flex items-center gap-2 mb-2">
          <MapPin className="w-4 h-4 text-cosmic-blue" strokeWidth={1.5} />
          <span className="text-sm text-slate-400">Current Position</span>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wider">Latitude</p>
            <p className="text-xl font-mono text-white">{iss.latitude?.toFixed(4)}°</p>
          </div>
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wider">Longitude</p>
            <p className="text-xl font-mono text-white">{iss.longitude?.toFixed(4)}°</p>
          </div>
        </div>
      </div>

      {/* NASA Spot the Station Link */}
      <a
        href={iss.spot_the_station_url}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary w-full flex items-center justify-center gap-2"
        data-testid="iss-spot-station-btn"
      >
        <ExternalLink className="w-4 h-4" strokeWidth={1.5} />
        NASA Spot the Station
      </a>
    </div>
  );
};

export const ISSWidgetSkeleton = () => (
  <div className="glass-card p-6">
    <div className="flex items-center justify-between mb-4">
      <div className="skeleton h-6 w-32 rounded" />
      <div className="skeleton h-6 w-20 rounded-full" />
    </div>
    <div className="skeleton h-24 w-full rounded-xl mb-4" />
    <div className="skeleton h-12 w-full rounded-xl" />
  </div>
);
